import { CSSProperties, SVGProps } from 'react';
import Admin from './svg-icons/Admin';
import Arrow from './svg-icons/Arrow';
import ArrowTriangle from './svg-icons/ArrowTriangle';
import Anchor from './svg-icons/Anchor';
import Check from './svg-icons/Check';
import Eye from './svg-icons/Eye';
import DataPanel from './svg-icons/DataPanel';
import FlagBR from './svg-icons/FlagBR';
import FlagUS from './svg-icons/FlagUS';
import Help from './svg-icons/Help';
import Logo from './svg-icons/Logo';
import LogoColored from './svg-icons/LogoColored';
import Maintenance from './svg-icons/Maintenance';
import Menu from './svg-icons/Menu';
import MenuClose from './svg-icons/MenuClose';
import Minus from './svg-icons/Minus';
import Monitor from './svg-icons/Monitor';
import Movement from './svg-icons/Movement';
import Pencil from './svg-icons/Pencil';
import Report from './svg-icons/Report';
import Home from './svg-icons/Home';
import Profile from './svg-icons/Profile';
import SignOut from './svg-icons/SignOut';
import X from './svg-icons/X';
import FlagES from './svg-icons/FlagES';
import Calendar from './svg-icons/Calendar';
import Error from './svg-icons/Error';
import Socket from './svg-icons/socket';
import Delete from './svg-icons/delete';
import Camera from './svg-icons/camera';
import Printer from './svg-icons/printer';
import Save from './svg-icons/save';
import Share from './svg-icons/share';
import Upload from './svg-icons/upload';
import Filter from './svg-icons/filter';
import FilterRemove from './svg-icons/filter-remove';
import ContainerRegular from './svg-icons/container-regular';
import ContainerIrregular from './svg-icons/container-irregular';
import PowerSocket from './svg-icons/power-socket';
import Cold from './svg-icons/cold';
import Frozen from './svg-icons/frozen';
import Consumption from './svg-icons/consumption';
import Energy from './svg-icons/energy';
import Bars from './svg-icons/bars';
import Financial from './svg-icons/Financial';
import Rate from './svg-icons/rate';
import Arrow2 from './svg-icons/arrow-2';
import Defrost from './svg-icons/defrost';
import Alert from './svg-icons/alert';
import Gear from './svg-icons/gear';
import Download from './svg-icons/download';
import Search from './svg-icons/Search';
import Container from './svg-icons/Container';
import NoEnergy from './svg-icons/no-energy';
import LogoR from './svg-icons/logo-r';
import Ventilation from './svg-icons/ventilation';
import Drop from './svg-icons/drop';
import InovaReefer from './svg-icons/InovaReefer';
import ZoomIn from './svg-icons/ZoomIn';
import ZoomOut from './svg-icons/ZoomOut';
import Bot from './svg-icons/bot';
import Coolingdown from './svg-icons/Coolingdown';
import Defrost2 from './svg-icons/Defrost2';
import Scroll from './svg-icons/Scroll';
import RewindCircle from './svg-icons/RewindCircle';

// SVG icon components should be listed here
const Icons = {
	FlagBR,
	FlagUS,
	Logo,
	Arrow,
	LogoColored,
	Menu,
	Monitor,
	Anchor,
	Search,
	Report,
	Movement,
	DataPanel,
	Maintenance,
	Admin,
	Help,
	MenuClose,
	Home,
	Profile,
	SignOut,
	ArrowTriangle,
	X,
	Minus,
	Check,
	Eye,
	Pencil,
	FlagES,
	Calendar,
	Error,
	Socket,
	Delete,
	Camera,
	Printer,
	Save,
	Share,
	Upload,
	Filter,
	FilterRemove,
	Container,
	ContainerRegular,
	ContainerIrregular,
	PowerSocket,
	Cold,
	Frozen,
	Consumption,
	Energy,
	Bars,
	Financial,
	Rate,
	Arrow2,
	Defrost,
	Alert,
	Gear,
	Download,
	NoEnergy,
	LogoR,
	Ventilation,
	Drop,
	InovaReefer,
	ZoomIn,
	ZoomOut,
	Bot,
	Coolingdown,
	Defrost2,
	Scroll,
	RewindCircle
} as const;

export type IIcons = keyof typeof Icons;

export interface SVGIconProps extends SVGProps<SVGSVGElement> {
	icon: IIcons;
	className?: string;
	style?: CSSProperties;
}

// Default icon component for all SVG icons
const SVGIcon = ({ icon, color, ...props }: SVGIconProps) => {
	const Icon = Icons[icon];
	return <Icon {...props} />;
};

export default SVGIcon;
